import AssetsProvider from '../../providers/AssetsProvider'

class AssetsService {
  constructor () {
    this.assetsById = {}
    this.severityStateByAssetId = {}
  }

  getAssets () {
    return Object.values(this.assetsById)
  }
  getAssetById (id) {
    return this.assetsById[id]
  }
  getAssetsByIds (ids) {
    return Object.values(this.assetsById).filter(a => ids.includes(a.id))
  }
  getAssetsByUniqueIds (ids) {
    return Object.values(this.assetsById).filter(a => ids.includes(a.uniqueId))
  }
  addOrUpdateAssets (assets) {
    assets.forEach(asset => {
      this.assetsById[asset.id] = asset
      this.severityStateByAssetId[asset.id] = asset.assetStates.find(as => as.name === 'severity')

      if (asset.children) {
        this.addOrUpdateAssets(asset.children)
      }
    })
  }
  async getToken (asset) {
    return AssetsProvider.getToken(asset)
  }
  getSeverityStateByAssetId () {
    return this.severityStateByAssetId
  }
  getHighestSeverity (ids) {
    let severityState
    ids.forEach(id => {
      let asset = this.assetsById[id]
      severityState = this.severityStateByAssetId[id]

      if (!asset.children) {
        return
      }
      let childSeverityState = this.getHighestSeverity(asset.children.map(c => c.id))
      if (!childSeverityState) {
        return
      }

      if (parseInt(childSeverityState.value) < 1 || parseInt(childSeverityState.value) > 3) {
        return
      }

      if (!severityState || parseInt(childSeverityState.value) > parseInt(severityState.value)) {
        severityState = childSeverityState
      }
    })
    return severityState
  }
}

export default new AssetsService()



// WEBPACK FOOTER //
// ./src/services/r8/AssetsService.js